import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GerenciarOcorrenciasService {

  constructor(private readonly http: HttpClient) { }

  public getAllHistorico(url) {
    return this.http.get(`/apiconnect/importation/occurrence/filters${url}`);
  }

  public getAllSegundaViaCartao(idUsuario, idProduto) {
    return this.http.get(`/apiconnect/importation/occurrence/cards/${idUsuario}/users/${idProduto}/products`);
  }

  public getTipoOcorrencia() {
    return this.http.get(`/apiconnect/importation/occurrence/types`);
  }

  public getSituacaoOcorrencia() {
    return this.http.get(`/apiconnect/importation/occurrence/situations`);
  }

  public getDetalhesOcorrencia(idOcorrencia) {
    return this.http.get(`/apiconnect/importation/occurrence/detail/${idOcorrencia}/occurrences`);
  }

  public gethistoricoOcorrencia(idOcorrenciaEmpresa, idEmpresa) {
    return this.http.get(`/apiconnect/importation/occurrence/historic/${idOcorrenciaEmpresa}/ocurrences/${idEmpresa}/companies`);
  }

  public getSituacaoOcorrenciaSegundaVia() {
    return this.http.get(`/apiconnect/importation/occurrence/cards/situations`);
  }

  public getSituacaoOcorrenciaFixas() {
    return of({
      response: [
        { codigo: 'W', descricao: 'NÃO FINALIZADAS' },
        { codigo: 'T', descricao: 'QUALQUER SITUAÇÃO' },
        { codigo: 'A', descricao: 'ABERTAS' },
        { codigo: 'B', descricao: 'CONFIRMADAS' },
        { codigo: 'C', descricao: 'EM PRODUÇÃO' },
        { codigo: 'X', descricao: 'ENCERRADAS' },
      ]
    });
  }

  public getAllOcorrenciaCartao(url) {
    return this.http.get(`/apiconnect/importation/occurrence/cards/filters${url}`);
  }

  public getAllUsuarios(idEmpresa: any, tipoOcorrencia: any) {
    return this.http.get(`/apiconnect/importation/occurrence/type?idEmpresa=${idEmpresa}&idTipoOcorrencia=${tipoOcorrencia}`);
  }

  public getAllProdutos(url) {
    return this.http.get(`/apiconnect/importation/occurrence/products${url}`);
  }

  public getContatos(idEmpresa){
    return this.http.get(`/apiconnect/importation/contacts/list/${idEmpresa}/companies`);
  }

  public postOcorrencia( url, file ){
    return this.http.post (`/apiconnect/importation/occurrence${url}` , file);
  }

  public getCsv(url){
    return this.http.get(`/apiconnect/importation/occurrence/csv/filters${url}`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  public getArquivoOcorrencia(idArquivo:any){
    return this.http.get(`/apiconnect/importation/occurrence/historic-file/${idArquivo}/files`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

}
